import { all, fork } from 'redux-saga/effects';
import authSaga from './auth';
import affiliateSaga from './affiliate';
import adminSaga from './admin';

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(affiliateSaga),
    fork(adminSaga)
  ]);
}
